import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from './auth.service';
import { resolveRoleLanding } from './role-landing';

export const authGuard: CanActivateFn = (_route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (auth.isAuthenticated()) {
        return true;
    }

    return auth.loadCurrentUser().pipe(
        map(() => true),
        catchError(() => of(router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } })))
    );
};

/** Send users who are already signed in away from the login page (role-based home). */
export const loginGuestGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    if (auth.isAuthenticated()) {
        const landing = resolveRoleLanding(auth.currentUser()?.roles);
        return router.createUrlTree([landing.defaultRoute]);
    }
    return true;
};
